import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sid) return undefined;
    let cancelled = false;
    let count = 0;
    const poll = async () => {
      count += 1;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setStatus(r.data.payment_status);
        if (r.data.payment_status === "paid" || count >= 15) return;
      } catch {
        /* transient poll failure — retried on interval */
      }
      if (!cancelled) setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  return (
    <div className="max-w-2xl mx-auto text-center py-24 px-6 fade-in-up">
      <div className="w-16 h-16 border-2 border-[#15803D] rounded-full grid place-items-center mx-auto mb-6"><CheckCircle2 className="w-8 h-8 text-[#15803D]" /></div>
      <h1 className="font-serif text-3xl font-bold text-[#0A192F] mb-3">Payment {status === "paid" ? "confirmed" : "processing"}.</h1>
      <p className="text-slate-600 mb-6">Session: <span className="font-mono text-xs">{sid?.slice(0,32)}…</span></p>
      <Link to="/portal/invoices" className="btn-navy px-6 py-3 text-[12px] uppercase tracking-widest inline-flex" data-testid="return-invoices">Return to Invoices</Link>
    </div>
  );
}
